/**
 * Box.tsx
 * -------
 * Styled container for content blocks.
 * - Optional center alignment.
 */

import React from 'react';

interface BoxProps extends React.HTMLAttributes<HTMLDivElement> {
  onClick?: () => void;
  children: React.ReactNode;
  ariaLabel?: string;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  itemsCenter?: boolean;
}

const Box: React.FC<BoxProps> = ({ children, className = '', itemsCenter = true, ...props }) => (
  <div
    className={`flex flex-col backdrop-blur-lg rounded-3xl 
      shadow-xl border border-blue-200 p-8
      animate-fade-in
      ${itemsCenter ? 'items-center' : ''} 
      ${className}`}
    {...props}
  >
    {children}
  </div>
);

export default Box;
